module.exports = __webpack_public_path__ + "static/img/tongguo.a0a0a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check/tongguo.png
// module id = OY6/
// module chunks = 1